import _axios from '@/plugins/axios'
import store from '@/store'
import { MINIMAX_HOST, STATIC_HOST } from '@/api/constants'
import {
  apiT2A,
  apiT2A_await,
  apiT2A_order,
  apiT2A_promise,
  apiT2A_promise_array,
  apiT2AStream,
  processData
} from '@/api/app'
import { askApiStreamTts } from '@/api/askApiStreamTts'

const preUrl = STATIC_HOST
export const getAliYunTTSToken = () => {
  return new Promise((resolve, reject) => {
    _axios({
      url: preUrl + 'media/get_sdk_token',
      // url: "/baidu-asr-token-api/token",
      method: 'get',
      params: {}
    })
      .then((res) => {
        if (res?.status != 'ok') {
          return reject(res)
        }
        return resolve(res)
      })
      .catch((error) => {
        return reject(error)
      })
  })
}
export const getBaiduPingTest = () => {
  return new Promise((resolve, reject) => {
    _axios({
      url: 'https://jsonplaceholder.typicode.com/posts',
      // url: "/baidu-asr-token-api/token",
      method: 'get',
      params: {}
    })
      .then((res) => {
        return resolve(res)
      })
      .catch((error) => {
        return reject(error)
      })
  })
}

export const aLiYunTTSApi = (token = '', text) => {
  if (!(token && text)) {
    return Promise.reject('缺少必备参数')
  }
  return new Promise((resolve, reject) => {
    _axios({
      // url: "https://nls-gateway-cn-shanghai.aliyuncs.com/stream/v1/tts",
      url: '/aliyun-tts-api/stream/v1/tts',
      method: 'post',
      headers: {
        'Content-Type': 'application/json'
      },
      timeout: 1000 * 30,
      data: {
        appkey: 'kuAWHCg2JKS7X6ry',
        text: text,
        token: token,
        format: 'mp3'
      }
    })
      .then((res) => {
        if (res?.status) {
          return reject(res)
        }
        return resolve(res)
      })
      .catch((error) => {
        return reject(error)
      })
  })
}

// 原来阿里云tts方案 aLiYunTTSUrl_old_noah
export const aLiYunTTSUrl = (text) => {
  if (!text) {
    // return Promise.reject("缺少必备参数");
    return ''
  }
  if (!store?.state?.vuex_aliyun_tts_token) {
    // return Promise.reject("缺少TTS Token");
    console.log('缺失阿里云tts的token')
    return ''
  }

  //store.commit('updateVuex_aliyun_tts_token', '08d3ee06faae4fec86170ea957ed27df')
  const result = `https://nls-gateway-cn-shanghai.aliyuncs.com/stream/v1/tts?appkey=${'kuAWHCg2JKS7X6ry'}&token=${
    store?.state?.vuex_aliyun_tts_token || ''
  }&volume=80&text=${text}&voice=${
    store?.state?.vuex_app_video_info?.tts_template_id || 'xiaoyun'
  }&format=mp3`
  // vuex_app_user_info?.tts_template_id
  // IOS 不支持 wav

  // return Promise.resolve(result);
  return result
}

export const aLiYunTTSUrlParams = (text, speech_rate) => {
  if (!text) {
    //return Promise.reject("缺少必备参数");
    return ''
  }
  if (!store?.state?.vuex_aliyun_tts_token) {
    console.log('缺少TTS Toke')
    //return Promise.reject("缺少TTS Token");
    return ''
  }

  //store.commit('updateVuex_aliyun_tts_token', '08d3ee06faae4fec86170ea957ed27df')
  const result = `https://nls-gateway-cn-shanghai.aliyuncs.com/stream/v1/tts?appkey=${'kuAWHCg2JKS7X6ry'}&token=${
    store?.state?.vuex_aliyun_tts_token || ''
  }&volume=80&text=${text}&voice=${
    store?.state?.vuex_app_video_info?.tts_template_id || 'xiaoyun'
  }&speech_rate=${speech_rate}&format=mp3`
  // IOS 不支持 wav

  // return Promise.resolve(result);
  return result
}

// _promise
export const aLiYunTTSUrl_promise = async (text) => {
  return new Promise(async (resolve, reject) => {
    const userInfo = store.state.vuex_app_user_info
    let params = {
      'model': "speech-01-turbo",
      'text': text,
      'stream': false,
      /* 'timber_weights': [
        {
          "voice_id": "male-qn-qingse",
          "weight": 1
        },
        {
          "voice_id": "female-shaonv",
          "weight": 1
        }
      ], */
      "voice_setting":{
        "voice_id": userInfo.voice_id || 'female-shaonv',
        "speed": 1,
        "vol": 1,
        "pitch": 0
      },
      "audio_setting":{
        "sample_rate": 32000,
        "bitrate": 128000,
        "format": "mp3"
      }
    };
    const defaultGroupId = '1810541336101667533'
    const defaultToken = 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJHcm91cE5hbWUiOiLll7flkZzkuJbnlYzvvIjmt7HlnLPvvInnvZHnu' +
      '5znp5HmioDmnInpmZDlhazlj7giLCJVc2VyTmFtZSI6Iueoi-iwpiIsIkFjY291bnQiOiIiLCJTdWJqZWN0SUQiOiIxODEwNTQxMzM2MTEwMDU2MTQ' +
      'xIiwiUGhvbmUiOiIxODY4MjEyODY4OSIsIkdyb3VwSUQiOiIxODEwNTQxMzM2MTAxNjY3NTMzIiwiUGFnZU5hbWUiOiIiLCJNYWlsIjoiIiwiQ3JlY' +
      'XRlVGltZSI6IjIwMjQtMDgtMTUgMTY6MDM6MjYiLCJpc3MiOiJtaW5pbWF4In0.G9ei6Pgb6zNaevpV_dAOpUeKhJykE7NQas4lWyYbZQSRSCCz7' +
      'vesNdsP-3GvAf0fwebGVC8YmFR8nSvWq_v4VzyZJQcYYfM4jDpzaxNhCueZ0AmVVp6BgU_mMcb--27bEAD8yI6F5PxADA8h8enMn7WKWr1Rjgy' +
      'LatqUa0nWdoe2K6GY5oZWUcDk5SP_dOZllm0fc0ar60hbk8tZIBjGmG6DLlUMtyUen89JZArrmVm7r3GKw0FgCr9WV3b5ViCPH-x70GuyqaNFjA7' +
      'fDpX_gN7maregAFqhPLSpp6b78KIE0jV_n8QMs7cEdi_8bCgtkwe6mmoDpVN1gTGGqVc6jw'
    const ttsInfo = store.state.ttsInfo
    const group_id = ttsInfo.group_id !== '' ? ttsInfo.group_id : defaultGroupId
    const token = ttsInfo.accessToken !== '' ? ttsInfo.accessToken : defaultToken
    await apiT2A(params, group_id, token).then(res => {
      let hexString = res?.data.audio;
      let result = [];
      for (let i = 0; i < hexString.length; i += 2) {
        result.push(parseInt(hexString.substr(i, 2), 16));
      }

      let blob = new Blob([new Uint8Array(result)], { type: 'audio/wav' }) // wav mp3
      let url = (window.URL || window.webkitURL || window || {}).createObjectURL(blob)

      var xhr = new XMLHttpRequest();
      xhr.open('GET', url, true);
      xhr.responseType = 'blob';
      xhr.onreadystatechange = function() {
        if (xhr.readyState === 4 && xhr.status == 200) {
          let audioBlob = xhr.response;
          let url = (window.URL || window.webkitURL || window || {}).createObjectURL(audioBlob);

          // 清理 Blob 和 URL 变量
          /* URL.revokeObjectURL(url);
          URL.revokeObjectURL(audioUrl); */
          resolve(url);
          // now url is ready
        }
      };
      xhr.send();
      // console.log('apiT2A url', url);
      resolve(url);
    }).catch(error => {
      console.log('apiT2A error', error);
      reject(error);
    });
  });
};

// 新版tts 单个请求方法 初始写法
export const aLiYunTTSUrl_chu_shi_fun = async (text) => {
  console.log('aLiYunTTSUrl 传入的文本为：', text)
  const userInfo = store.state.vuex_app_user_info
  let params = {
    'model': "speech-01-turbo",
    'text': text,
    'stream': false,
    /* 'timber_weights': [
      {
        "voice_id": "male-qn-qingse",
        "weight": 1
      },
      {
        "voice_id": "female-shaonv",
        "weight": 1
      }
    ], */
    "voice_setting":{
      "voice_id": userInfo.voice_id || 'female-shaonv',
      "speed": 1,
      "vol": 1,
      "pitch": 0
    },
    "audio_setting":{
      "sample_rate": 32000,
      "bitrate": 128000,
      "format": "mp3"
    }
  };
  const defaultGroupId = '1810541336101667533'
  const defaultToken = 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJHcm91cE5hbWUiOiLll7flkZzkuJbnlYzvvIjmt7HlnLPvvInnvZHnu' +
    '5znp5HmioDmnInpmZDlhazlj7giLCJVc2VyTmFtZSI6Iueoi-iwpiIsIkFjY291bnQiOiIiLCJTdWJqZWN0SUQiOiIxODEwNTQxMzM2MTEwMDU2MTQ' +
    'xIiwiUGhvbmUiOiIxODY4MjEyODY4OSIsIkdyb3VwSUQiOiIxODEwNTQxMzM2MTAxNjY3NTMzIiwiUGFnZU5hbWUiOiIiLCJNYWlsIjoiIiwiQ3JlY' +
    'XRlVGltZSI6IjIwMjQtMDgtMTUgMTY6MDM6MjYiLCJpc3MiOiJtaW5pbWF4In0.G9ei6Pgb6zNaevpV_dAOpUeKhJykE7NQas4lWyYbZQSRSCCz7' +
    'vesNdsP-3GvAf0fwebGVC8YmFR8nSvWq_v4VzyZJQcYYfM4jDpzaxNhCueZ0AmVVp6BgU_mMcb--27bEAD8yI6F5PxADA8h8enMn7WKWr1Rjgy' +
    'LatqUa0nWdoe2K6GY5oZWUcDk5SP_dOZllm0fc0ar60hbk8tZIBjGmG6DLlUMtyUen89JZArrmVm7r3GKw0FgCr9WV3b5ViCPH-x70GuyqaNFjA7' +
    'fDpX_gN7maregAFqhPLSpp6b78KIE0jV_n8QMs7cEdi_8bCgtkwe6mmoDpVN1gTGGqVc6jw'
  const ttsInfo = store.state.ttsInfo
  const group_id = ttsInfo.group_id !== '' ? ttsInfo.group_id : defaultGroupId
  const token = ttsInfo.accessToken !== '' ? ttsInfo.accessToken : defaultToken
  /* const res = await apiT2A_await(params, group_id, token) */
  try {
    console.log('请求前文本：', params.text)
    const response =  await _axios({
      url: MINIMAX_HOST + '/v1/t2a_v2?GroupId=' + group_id,
      method: 'post',
      data: params,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': "Bearer " + token
      }
    });
    console.log('apiT2A axios params text ', params.text);
    console.log('apiT2A response', response);

    if (response?.base_resp?.status_code === 0) {
      // 在这里处理返回的结果
      console.log('网络请求完成后的结果, response', response);


      let hexString = response?.data.audio;
      let result = [];
      for (let i = 0; i < hexString.length; i += 2) {
        result.push(parseInt(hexString.substr(i, 2), 16));
      }
      let blob = new Blob([new Uint8Array(result)], { type: 'audio/mp3' }) // wav mp3
      let url = (window.URL || window.webkitURL || window || {}).createObjectURL(blob)
      console.log('blob url:', url)
      return url
    } else {
      return { error: 'error' };
    }
  } catch (error) {
    return { error: 'error' };
  }


  /* var xhr = new XMLHttpRequest();
  xhr.open('GET', url, true);
  xhr.responseType = 'blob';
  xhr.onreadystatechange = function() {
    if (xhr.readyState === 4 && xhr.status == 200) {
      let audioBlob = xhr.response;
      let url = (window.URL || window.webkitURL || window || {}).createObjectURL(audioBlob);
      console.log('xhr url:', url)
      return url

    }
  };
  xhr.send(); */
};

export const aLiYunTTSUrl_axios_promise = async (text) => {
  // console.log('aLiYunTTSUrl 传入的文本为：', text)
  const userInfo = store.state.vuex_app_user_info
  let params = {
    'model': "speech-01-turbo",
    'text': text,
    'stream': false,
    /* 'timber_weights': [
      {
        "voice_id": "male-qn-qingse",
        "weight": 1
      },
      {
        "voice_id": "female-shaonv",
        "weight": 1
      }
    ], */
    "voice_setting":{
      "voice_id": userInfo.voice_id || 'female-shaonv',
      "speed": 1,
      "vol": 1,
      "pitch": 0
    },
    "audio_setting":{
      "sample_rate": 32000,
      "bitrate": 128000,
      "format": "mp3"
    }
  };
  const defaultGroupId = '1810541336101667533'
  const defaultToken = 'eyJhbGciOiJSUzI1NiIsInR5cCI6IkpXVCJ9.eyJHcm91cE5hbWUiOiLll7flkZzkuJbnlYzvvIjmt7HlnLPvvInnvZHnu' +
    '5znp5HmioDmnInpmZDlhazlj7giLCJVc2VyTmFtZSI6Iueoi-iwpiIsIkFjY291bnQiOiIiLCJTdWJqZWN0SUQiOiIxODEwNTQxMzM2MTEwMDU2MTQ' +
    'xIiwiUGhvbmUiOiIxODY4MjEyODY4OSIsIkdyb3VwSUQiOiIxODEwNTQxMzM2MTAxNjY3NTMzIiwiUGFnZU5hbWUiOiIiLCJNYWlsIjoiIiwiQ3JlY' +
    'XRlVGltZSI6IjIwMjQtMDgtMTUgMTY6MDM6MjYiLCJpc3MiOiJtaW5pbWF4In0.G9ei6Pgb6zNaevpV_dAOpUeKhJykE7NQas4lWyYbZQSRSCCz7' +
    'vesNdsP-3GvAf0fwebGVC8YmFR8nSvWq_v4VzyZJQcYYfM4jDpzaxNhCueZ0AmVVp6BgU_mMcb--27bEAD8yI6F5PxADA8h8enMn7WKWr1Rjgy' +
    'LatqUa0nWdoe2K6GY5oZWUcDk5SP_dOZllm0fc0ar60hbk8tZIBjGmG6DLlUMtyUen89JZArrmVm7r3GKw0FgCr9WV3b5ViCPH-x70GuyqaNFjA7' +
    'fDpX_gN7maregAFqhPLSpp6b78KIE0jV_n8QMs7cEdi_8bCgtkwe6mmoDpVN1gTGGqVc6jw'
  const ttsInfo = store.state.ttsInfo
  const group_id = ttsInfo.group_id !== '' ? ttsInfo.group_id : defaultGroupId
  const token = ttsInfo.accessToken !== '' ? ttsInfo.accessToken : defaultToken


  const response = await apiT2A_promise(params, group_id, token) // apiT2A_promise apiT2A_order
  console.log('apiT2A_promise 网络请求完成后的结果 response.text', response.url, response.text )
  /*  let hexString = response?.data.audio;
   let result = [];
   for (let i = 0; i < hexString.length; i += 2) {
     result.push(parseInt(hexString.substr(i, 2), 16));
   }

   let blob = new Blob([new Uint8Array(result)], { type: 'audio/mp3' }) // wav mp3
   let url = (window.URL || window.webkitURL || window || {}).createObjectURL(blob)
   console.log('blob url:', url)
   console.log('blob url response:', response)
   return url */
  return response.url

  /* var xhr = new XMLHttpRequest();
  xhr.open('GET', url, true);
  xhr.responseType = 'blob';
  xhr.onreadystatechange = function() {
    if (xhr.readyState === 4 && xhr.status == 200) {
      let audioBlob = xhr.response;
      let url = (window.URL || window.webkitURL || window || {}).createObjectURL(audioBlob);
      console.log('xhr url:', url)
      return url

    }
  };
  xhr.send(); */
};



export const clearRequestArray = () => {
  console.log('清空 enter 真正 clearRequestArray')
  clearController2()
  requestArray = []
}

let requestArray = []
let controller = null;
let signal = null;
// 创建 AbortController 实例
export const setNewAbortController2 = async () => {
  clearController2();
  // 加这玩意停不了
  // await setTimeout(() => {
  controller = new AbortController();
  signal = controller.signal;
  return signal
  // }, 0);
};
export const controllerAbort2 = (a) => {
  console.log('进入中断 enter controllerAbort2')
  if (controller) {
    console.log('进入中断 enter controllerAbort2 有 controller', signal?.aborted)
    if (signal?.aborted === false) { // 没被中断
      console.log('进入中断 执行中断abort')
      controller?.abort?.() // 进行中断
    }
  }
  // clearController2();
};

export const clearController2 = () => {
  controller = null;
  signal = null;
};

export const shiftOriginList = () => {
  console.log('enter shiftOriginList 缩减一次当前原始数组')
  if (requestArray.length > 0){
    if(requestArray[0].url && requestArray[0].url !== ''){
      console.log('移除队列的第一句话', requestArray[0].text)
      requestArray = requestArray.slice(1)
    } else {
      console.log('*** 因为没有url 所有无需移除队列的第一句话')
    }
  }
  return requestArray
}
export const logRequestArray = () => {
  console.log('logRequestArray')
  console.log(requestArray)
}



export const requestMiniMaxTts = (text, index, paramsObj, isArt) => {
  return new Promise(async (resolve, reject) =>{
    const userInfo = store.state.vuex_app_user_info
    let params = {
      'model': "speech-01-turbo",
      'text': text,
      'stream': false,
      "voice_setting":{
        "voice_id": userInfo.voice_id || 'female-shaonv',
        "speed": paramsObj?.speed || 1, // 范围[0.5,2]，默认值为1.0
        "vol": 1,
        "pitch": 0
      },
      "audio_setting":{
        "sample_rate": 32000,
        "bitrate": 128000,
        "format": "mp3"
      }
    };

    const ttsInfo = store.state.ttsInfo
    const group_id = ttsInfo.group_id
    const token = ttsInfo.accessToken

    requestArray.push({
      index: index,
      isArt: isArt,
      text: '',
      url: ''
    })
    // 监听取消信号

    try {
      if (controller == null){
        await setNewAbortController2()
      }

    } catch (error) {
      console.error(`requestMiniMaxTts getNewAbort error: `,error)
    }

    _axios({
      url: MINIMAX_HOST + '/v1/t2a_v2?GroupId=' + group_id,
      method: 'post',
      data: params,
      headers: {
        'Content-Type': 'application/json',
        'Authorization': "Bearer " + token
      }
    })
      .then((res) => {
        if (res?.base_resp?.status_code === 0) {
          if (res?.data.audio !== ''){
            // console.log('T start processData', readTime())
            processData(res?.data.audio).then(url => {
              // console.log('signal : ', signal)
              if (signal.aborted) {
                return reject({
                  url: '',
                  text: 'Promise cancelled',
                  index: index,
                  isArt: isArt
                })
              } else {
                let item = {
                  url: url,
                  text: params.text,
                  index: index,
                  isArt: isArt
                }
                const findIndex = requestArray.findIndex( t => t.index === item.index)
                if(findIndex !== -1){
                  requestArray[findIndex] = item
                }
                return resolve(requestArray)
                // console.log('T finish processData', readTime())
              }
            })
          }
        } else {
          return reject({
            url: '',
            text: 'error tts',
            index: index,
            data: res?.base_resp
          }) // return
        }
      })
      .catch((error) => {
        return  reject({
          url: '',
          text: 'error tts' + error.getMessage() || error,
          index: index
        }) // return
      })

    /*console.log('请求问题后 响应的问题index', response.index)
    console.log('apiT2A_promise 网络请求完成后的结果 response', response )

    console.log('noahTest before requestArray', requestArray) */
  })
}

export  function aLiYunTTSUrl_new(text) {
  askApiStreamTts(text)
}
